<template>
  <!-- 主页分流，不同的系统，显示不同的主页，根据一级商户不同(软件平台方)显示 -->
  <div class="home-page">
    <component v-if="!!homeName && homeName !== 'NONE'" :is="homeName"/>
    <error404 v-else title="首页功能尚未开放"/>
  </div>
</template>

<script>
// 主页模板
import RoadHomeMain from "@/views/h5/luqiao/home/RoadHomeMain.vue";
import FHLHomeMain from "@/views/h5/ai/home/FHLHomeMain.vue";
import Error404 from "@/views/h5/common/error/Error404.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import commonApi from "@/api/commonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "HomePage",
  components: {
    Error404, RoadHomeMain, FHLHomeMain
  },
  data() {
    return {
      // homeName: process.env.VUE_APP_HOME_MAIN,
      homeName: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    // 获取配置信息
    // 读取系统配置的主页
    commonApi.findSetting("HOME_PAGE").then(res => {
      this.homeName = res.settingValue;
    })

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.home-page{
  //background: #f8fafc !important;
}
</style>